import { render, staticRenderFns } from "./pointRule.vue?vue&type=template&id=a0133192&"
import script from "./pointRule.vue?vue&type=script&lang=js&"
export * from "./pointRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports